import { __rest } from "tslib";
import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { Slot } from '@cmpkit/utils';
const ListGroup = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    const Comp = props.asChild ? Slot : 'ul';
    return (React.createElement(Comp, Object.assign({ className: clsx('list-group', className), ref: ref }, props)));
});
const ListGroupItem = forwardRef((_a, ref) => {
    var { className, disabled, active } = _a, props = __rest(_a, ["className", "disabled", "active"]);
    const Comp = props.asChild ? Slot : 'li';
    return (React.createElement(Comp, Object.assign({ ref: ref, className: clsx('list-group-item', {
            disabled: disabled,
            active: active,
        }, className) }, props)));
});
const ListGroupInner = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({ ref: ref, className: clsx('flex items-center justify-between', className) }, props)));
});
const ListGroupStart = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({ ref: ref, className: clsx('mr-1 flex items-center', className) }, props)));
});
const ListGroupEnd = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement("div", Object.assign({ ref: ref, className: clsx('ml-auto flex items-center', className) }, props)));
});
const ListGroupContent = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement("div", Object.assign({ ref: ref, className: clsx('mr-auto', className) }, props));
});
export { ListGroup, ListGroupItem, ListGroupInner, ListGroupStart, ListGroupEnd, ListGroupContent, };
//# sourceMappingURL=index.js.map